import React from "react";
import ExpandableSVG from "../assets/expand.svg"; 

const ExpandSVG = ({ onClick, fill="#004225", width=24, height=24 }) => {
    return (
        <div onClick={onClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
                <path d="M12 15.375L6 9.37498L7.4 7.97498L12 12.575L16.6 7.97498L18 9.37498L12 15.375Z" fill={fill}/>
            </svg>
        </div>
    ); 
}; 

export default ExpandSVG;